module.exports = __webpack_public_path__ + "img/icon_check.849a8960.png";